// removed by extract-text-webpack-plugin
module.exports = {"bgLeftMenu":"#304156","bgHeadNavbar":"#e9e9e9","bgMain":"#eee","leftMenuColor":"#bfcbd9","leftMenuActiveColor":"#ffd04b","navbarHeight":"40px"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/param.scss
// module id = B/qn
// module chunks = 41